import { render } from "./NewUserForm.vue?vue&type=template&id=4ae11e41&scoped=true"
import script from "./NewUserForm.vue?vue&type=script&lang=js"
export * from "./NewUserForm.vue?vue&type=script&lang=js"

import "./NewUserForm.vue?vue&type=style&index=0&id=4ae11e41&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae11e41"]])

export default __exports__